// extracted by mini-css-extract-plugin
export default {"container":"ProductMainDescription_container__cyd0o","header":"ProductMainDescription_header__xaNVl","skipSidebar":"ProductMainDescription_skipSidebar__+ZSzZ"};